<template>
  <div>
    <NavHeaderBar :title="title" :onClickRight="onClickRight" rightArrow />
    <div class="showimg-dom">
      <div class="empty" v-if="((!showData.pic)&&(!showData.video))">敬请期待</div>
      <van-sticky v-if="showData.video">
        <div id="dplayer"></div>
      </van-sticky>
      <div v-if="showData.video != ''" style="padding-top: 10px;"></div>
      <div v-if="showData.pic != ''">
        <img :src="showData.pic" />
      </div>
    </div>
  </div>
</template>
<script>

import { getCorpCode } from "@/config/yqy";
import DPlayer from "dplayer";



export default {
  name: "showImg",
  data: function () {
    return {
      url: "",
      title: "药大咖",
      showData: {
        video: "", pic: ""
      }
    };
  },
  mounted: function () {
    if (this.$route) {
      try {
        let d = JSON.parse(this.$route.query.url) // 如果不是json字符串就会抛异常
        this.showData.pic = d.pic ? d.pic : "";
        this.showData.video = d.video ? d.video : "";
      } catch (e) {
        this.showData.pic = this.$route.query.url ? this.$route.query.url : "";
        this.showData.video = "";
      }
      this.title = this.$route.query.title;
    }

    if (this.showData.video) {
      this.loadPlayer();
    }


  },
  methods: {
    loadPlayer() {
      this.$nextTick(() => {
        this.player = new DPlayer({
          container: document.getElementById("dplayer"),
          video: {
            url: this.showData.video.replace("http", "https"),
          },
          autoplay: true,
        });
      });
    },
    onClickRight() {
      this.$router.push({
        path: "/dw/",
        query: { corpCode: getCorpCode() }
      });
    }
  }
};
</script>
<style scoped>
.showimg-dom {
  width: 100%;
  padding-top: 40px;

}

.showimg-dom img {
  width: 100%;
}

.showimg-dom .empty {
  width: 100%;
  text-align: center;
  padding-top: 40px;
  font-size: 20px;
}
</style>
